module.exports = __webpack_public_path__ + "img/small business.9fae6f1d.png";